// src/app/shared/icons/fa-icons.ts
import {
  faUser,
  faUserCircle,
  faShoppingCart,
  faTachometerAlt,
  faBox,
  faList,
  faTags,
  faChevronDown,
  faPhone,
  faEnvelope,
  faQrcode,
  faStar,
  faDog,
  faCat,
  faShieldAlt,
  faDownload,
  faCheckCircle,
  faTimes,
  faEdit,
  faSave,
  faEye,
  faImage,
  faTrash,
  faPlus,
  faArrowLeft,
  faCircle,
  faArrowUp,
  faThumbsUp,
  faThumbsDown,
  faComment,
  faStar as faSparkles,
  faTshirt,
  faFutbol,
  faShoppingBag,
  faChartLine,
  faCalendar,
  faCircleExclamation,
  faArrowRight,
  faClock,
  faSearch,
  faClose,
  faLock,
  faEyeSlash,
  faShield,
  faArrowRotateLeft,
  faUserPlus,
  faGift,
  faThunderstorm,
  faAward,
  faHeart,
  faPlusMinus,
  faBold,
  faDiamond,
  faSun,
  faMoon,
  faFire,
  faCloud,
  faMusic,
  faCamera,
  faPersonDress,
  faChildDress,
  faBowlFood,
  faPlane,
  faShoePrints,
  faTable,
  faChevronRight,
  faChevronLeft,
  faStore,
  faLocationDot,
  faLaptop,
  faHome,
  faMobile,
  faUtensils,
  faDumbbell,
  faInfo,
  faTv,
  faSpa,
  faBook,
  faCab,
  faBuilding,
  faBriefcase,
  faCity,
  faNetworkWired,
  faPercent,
  faProjectDiagram,
  faCreditCard,
  faChartBar,
  faCalculator,
  faClipboard,
  faKey,
  faChevronUp,
  faMicrophone,
  faStop,
  faFileAudio,
  faWeightHanging,
  faWaveSquare,
  faExclamationCircle,
  faCashRegister,
  faArrowDown,
  faBullseye,
  faInbox,
  faBell,
  faVolumeMute,
  faVolumeUp,
  faPlay,
  faVideo,
  faCopy,
  faX,
  faHourglass,
  faRefresh,
  faLeaf,
  faGear
} from '@fortawesome/free-solid-svg-icons';
import { subscribeOn } from 'rxjs';

export const faIcons = {
  user: faUser,
  userplus:faUserPlus,
  userCircle: faUserCircle,
  cart: faShoppingCart,
  dashboard: faTachometerAlt,
  box: faBox,
  list: faList,
  tags: faTags,
  chevronDown: faChevronDown,
  phone: faPhone,
  envelope: faEnvelope,
  qrcode: faQrcode,
  star: faStar,
  dog: faDog,
  cat: faCat,
  shieldAlt: faShieldAlt,
  download: faDownload,
  checkCircle: faCheckCircle,
  times: faTimes,
  edit: faEdit,
  save: faSave,
  eye: faEye,
  image: faImage,
  trash: faTrash,
  plus: faPlus,
  arrowLeft: faArrowLeft,
  coins: faCircle,
  upload: faArrowUp,
  thumbsUp: faThumbsUp,
  thumbsDown: faThumbsDown,
  comment: faComment,
  sparkles: faSparkles,
  shirt: faTshirt,
  futbol: faFutbol,
  bagShopping: faShoppingBag,
  chartLine: faChartLine,
  arrowRight:faArrowRight,  
  calendar:faCalendar,
  exclamation:faCircleExclamation,
  clock:faClock,
  search:faSearch,
  close:faClose,
  lock:faLock,
  eyeSlash:faEyeSlash,
  shield:faShield,
  arrowrotateleft:faArrowRotateLeft,
  gift:faGift,
  thunderstorm:faThunderstorm,
  award:faAward,
  heart:faHeart,
  bolt:faBold,
  diamond: faDiamond,
  sun: faSun,
  moon: faMoon,
  fire: faFire,
  cloud: faCloud,
  music: faMusic,
  camera: faCamera,
  gamepad: faFutbol, 
  dress: faPersonDress,
  food: faBowlFood,
  plane: faPlane,
  sports: faShoePrints,
  table: faTable,
  chevronRight: faChevronRight,
  chevronLeft: faChevronLeft,
  store : faStore,
  locationDot : faLocationDot,
  laptop: faLaptop,
  home: faHome,
  mobile: faMobile,
  utensils: faUtensils,
  dumbbell: faDumbbell,
  check: faCheckCircle,
  info: faInfo,
  tv: faTv,
  spa: faSpa,
  book: faBook,
  car: faCab,
  arrowUp: faArrowUp,
  arrowDown:faArrowDown,
  trophy: faAward,
  shop :faStore,
  building : faBuilding,
  briefcase: faBriefcase,
  shoppingBag: faShoppingBag,
  city : faCity,
  comments: faComment,
  networkWired: faNetworkWired,
  percent: faPercent,
  projectDiagram: faProjectDiagram,
  creditCard: faCreditCard,
  chartBar: faChartBar,
  calculator: faCalculator,
  clipboard: faClipboard,
  key: faKey,
  retry: faArrowRotateLeft,
  chevronUp: faChevronUp,
  microphone:faMicrophone,
  stop:faStop,
  fileAudio:faFileAudio,
  weightHanging:faWeightHanging,
  waveSquare:faWaveSquare,
  exclamationTriangle:faExclamationCircle,
  exclamationCircle: faExclamationCircle,
  infoCircle: faInfo,
  subscription:faCashRegister,
  bullseye:faBullseye,
  diagram:faProjectDiagram,
  inbox:faInbox,
  bell: faBell,
  volumeMute:faVolumeMute,
  volumeUp:faVolumeUp,
  play:faPlay,
  video:faVideo,
  copy:faCopy,
  cross:faX,
  hourglass:faHourglass,
  refresh:faRefresh,
  leaf:faLeaf,
  settings:faGear
};
